/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';

@Component({
  standalone: false,
  selector: 'adn-top-stats-table-host',
  template: `
    <adn-top-stats-table
      [object]="object"
      [parentType]="parentType"
      [childType]="childType">
    </adn-top-stats-table>
  `
})
export class TopStatsTableHostComponent {
  @Input() object: any;
  @Input() parentType: string;
  @Input() childType: string;
}
